<template>
  <button @click="jumpAddOptionId({ jump })" v-show="show" class="btn btn__green"><i class="fa fa-plus"></i> {{$t('edit.sidebar.add_answer')}}</button>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  props: [
    'jump',
    'show',
  ],
  methods: mapActions([
    'jumpAddOptionId',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** AddOption.vue?c068c21a
 **/